import { Guardian } from '@xaamin/guardian';

Guardian.define('retencion.crear', (user) => {
  return user.can('retencion.crear');
});

Guardian.define('retencion.cancelar', (user) => {
  return user.can('retencion.cancelar');
});

Guardian.define('retencion.listar', (user) => {
  return user.can('retencion.listar');
});

Guardian.define('retencion.info', (user) => {
  return user.can('retencion.info');
});

Guardian.define('retencion.descargar.zip', (user) => {
  return user.can('retencion.descargar.zip');
});

Guardian.define('retencion.descargar.xml', (user) => {
  return user.can('retencion.descargar.xml');
});

Guardian.define('retencion.descargar.pdf', (user) => {
  return user.can('retencion.descargar.pdf');
});

Guardian.define('retencion.descarga.masiva.zip', (user) => {
  return user.can('retencion.descarga.masiva.zip');
});

Guardian.define('retencion.descarga.masiva.xml', (user) => {
  return user.can('retencion.descarga.masiva.xml');
});

Guardian.define('retencion.descarga.masiva.pdf', (user) => {
  return user.can('retencion.descarga.masiva.pdf');
});

Guardian.define('retencion.cancelar.masivo', (user) => {
  return user.can('retencion.cancelar.masivo');
});

Guardian.define('retencion.enviar.email.masivo', (user) => {
  return user.can('retencion.enviar.email.masivo');
});